<template>
  <div v-if="isVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" @click.self="$emit('cancel')">
    <div class="bg-white rounded-lg w-full sm:max-w-lg max-w-md shadow-lg flex flex-col pb-6 relative mx-4">
      <!-- Modal Header -->
      <button type="button" class="absolute top-3 right-3 text-2xl text-gray-400 hover:text-gray-600" @click="$emit('cancel')">
        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div class="flex flex-col items-center px-8 pt-8">
        <div class="flex items-center justify-center mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                <path d="M21 3.5C17.5388 3.5 14.1554 4.52636 11.2775 6.44928C8.39967 8.37221 6.15665 11.1053 4.83212 14.303C3.50758 17.5007 3.16102 21.0194 3.83627 24.4141C4.51151 27.8087 6.17822 30.9269 8.62564 33.3744C11.0731 35.8218 14.1913 37.4885 17.5859 38.1637C20.9806 38.839 24.4993 38.4924 27.697 37.1679C30.8947 35.8433 33.6278 33.6003 35.5507 30.7225C37.4736 27.8446 38.5 24.4612 38.5 21C38.4949 16.3603 36.6495 11.912 33.3687 8.63126C30.088 5.35048 25.6397 3.5051 21 3.5ZM21 29.75C20.6539 29.75 20.3155 29.6474 20.0278 29.4551C19.74 29.2628 19.5157 28.9895 19.3832 28.6697C19.2508 28.3499 19.2161 27.9981 19.2836 27.6586C19.3512 27.3191 19.5178 27.0073 19.7626 26.7626C20.0073 26.5178 20.3191 26.3511 20.6586 26.2836C20.9981 26.2161 21.3499 26.2508 21.6697 26.3832C21.9895 26.5157 22.2628 26.74 22.4551 27.0277C22.6474 27.3155 22.75 27.6539 22.75 28C22.75 28.4641 22.5656 28.9092 22.2374 29.2374C21.9093 29.5656 21.4641 29.75 21 29.75ZM22.75 22.75C22.75 23.2141 22.5656 23.6592 22.2374 23.9874C21.9093 24.3156 21.4641 24.5 21 24.5C20.5359 24.5 20.0908 24.3156 19.7626 23.9874C19.4344 23.6592 19.25 23.2141 19.25 22.75V14C19.25 13.5359 19.4344 13.0907 19.7626 12.7626C20.0908 12.4344 20.5359 12.25 21 12.25C21.4641 12.25 21.9093 12.4344 22.2374 12.7626C22.5656 13.0907 22.75 13.5359 22.75 14V22.75Z" fill="#FF4265"/>
            </svg>
        </div>
        <h3 class="text-base font-semibold text-center mb-2 text-custom_gray">¡Título optimizado con éxito!</h3>
        <p class="text-base font-normal text-custom_gray text-center mb-6">Ahora podemos mejorar también la descripción para que tu anuncio llegue a más interesados. <br> Si lo prefieres, publícalo tal como lo escribiste.</p>
      </div>
      <div class="flex justify-center gap-4 px-8">
        <button @click="$emit('publish')" class="text-base px-3 py-2 rounded-md border border-gray-300 bg-white text-gray-900 font-medium hover:bg-gray-100 transition">Publicar propiedad</button>
        <button @click="$emit('confirm')" class="text-base px-3 py-2 rounded-md bg-tuin-100 text-white font-medium hover:bg-tuin_hover transition">Optimizar con IA</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
</style>
